const ToolboxInfo = {
  maxInstances: {
    program_image_click_event_block: 2,
    show_image_block: 2,
  },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "program_image_click_event_block",
          },
          {
            kind: "block",
            type: "show_image_block",
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
